import { render } from "./RemixIcon.vue?vue&type=template&id=58410026"
import script from "./RemixIcon.vue?vue&type=script&lang=js"
export * from "./RemixIcon.vue?vue&type=script&lang=js"

import "./RemixIcon.vue?vue&type=style&index=0&id=58410026&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__